import DashboardCard from "../../../ui/DashboardCard/DashboardCard.tsx";
import type { AdultDashboardTeenItemResponse } from "../../../../types/adultDashboardTypes.ts";
import { toReadableDate } from "../shared/dashboardDisplay";

type AdultMyTeensBoxProps = {
  myTeens: AdultDashboardTeenItemResponse[];
  loading: boolean;
};

const AdultMyTeensBox = ({ myTeens, loading }: AdultMyTeensBoxProps) => {
  return (
    <DashboardCard
      title="View My Teens"
      subtitle="Open this to invite a teen or manage teens already linked to your account."
      to="/adult/guardian/teens"
    >
      {loading ? (
        <p className="text-sm text-myteengig-text-muted">Loading linked teens...</p>
      ) : myTeens.length === 0 ? (
        <p className="text-sm text-myteengig-text-muted">No linked teens yet. Open this card to invite your teen.</p>
      ) : (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {myTeens.map((teen) => (
            <div key={teen.teenUserId ?? teen.updatedAt} className="min-w-0 rounded-lg border border-myteengig-border bg-myteengig-background p-3">
              <p className="break-words font-semibold text-myteengig-text-primary">
                {[teen.firstName, teen.lastName].filter(Boolean).join(" ") || "Teen"}
              </p>
              <p className="mt-1 break-words text-sm text-myteengig-text-muted">{teen.email ?? "No email"}</p>
              <p className="mt-2 break-words text-xs text-myteengig-text-muted">Guardian status: {teen.guardianStatus}</p>
              <p className="mt-1 break-words text-xs text-myteengig-text-muted">Updated {toReadableDate(teen.updatedAt)}</p>
            </div>
          ))}
        </div>
      )}
    </DashboardCard>
  );
};

export default AdultMyTeensBox;
